module.exports = __webpack_public_path__ + "static/logo2-985f7ba696f167439012d7a1377bbe79.png";